import { defineVariants } from "@/runtime/style-engine/define-variants";

/**
 * Tailwind-like class variants for `<e-field>`.
 */
export const fieldClasses = defineVariants({
  base: `
    e-field
    flex
    gap-2
  `,

  variants: {
    orientation: {
      vertical: `flex-col`,
      horizontal: `flex-row items-center`,
    },
  },

  defaults: {
    orientation: "vertical",
  },
});

/**
 * Classes for field label wrapper
 */
export const fieldLabelWrapperClasses = "flex items-center gap-1";

/**
 * Classes for field content wrapper (wraps the input slot)
 */
export const fieldContentClasses = `flex-1 cursor-auto`;

/**
 * Classes for field message (description/error/hint)
 */
export const fieldMessageClasses = defineVariants({
  base: `
    text-xs
    mt-1
  `,

  variants: {
    type: {
      description: `text-gray-500 dark:text-gray-400`,
      error: `text-(--color-error)`,
      hint: `text-gray-400 dark:text-gray-500`,
    },
  },

  defaults: {
    type: "description",
  },
});

/**
 * Classes for required indicator
 */
export const fieldRequiredClasses = `text-(--color-error) text-sm ml-1`;
